import { ReactNode } from "react";

// LQC-3027 - an icon heading for the Edit / Save and Discard columns, as the blotter's
// trade-wide settings cog does; the colDef's headerTooltip names the column. Left, as
// the other headings start, lined up with the rows' pencil.
const DraftLegActionHeader = ({ icon, testId }: { icon?: ReactNode; testId: string }) => (
  <div
    data-testid={testId}
    id={testId}
    className="flex h-full w-full items-center justify-start pl-2 pr-1 text-xs text-gray-500 opacity-70 dark:text-gray-400"
  >
    {icon}
  </div>
);

export default DraftLegActionHeader;
